import { useEffect, useRef } from "react";

/**
 * Warns the user when they try to navigate away or refresh with unsaved changes.
 *
 * Handles:
 * - Browser refresh / tab close (`beforeunload`)
 * - Browser back/forward (`popstate` for reach-router SPA navigation)
 *
 * @param isDirty - Whether there are unsaved changes
 * @param message - Optional custom message (browsers mostly ignore custom text now)
 */
export const useUnsavedChangesWarning = (
	isDirty: boolean,
	message = "You have unsaved changes. Are you sure you want to leave?"
): void => {
	const messageRef = useRef(message);
	messageRef.current = message;

	// Browser refresh / tab close
	useEffect(() => {
		if (!isDirty) {
			return;
		}

		const handler = (e: BeforeUnloadEvent) => {
			e.preventDefault();
		};

		window.addEventListener("beforeunload", handler);
		return () => {
			window.removeEventListener("beforeunload", handler);
		};
	}, [isDirty]);
};
